export const DOC_TYPE_OPTIONS = [
  ["buro", "Buró de crédito"],
  ["pagare", "Pagaré"],
  ["contrato", "Contrato"],
  ["financieros", "Financieros"],
  ["aval", "Aval u obligado solidario"],
  ["identificacion", "Identificación"],
  ["csf", "CSF"],
  ["pm_acta", "PM acta constitutiva, poderes"],
  ["comprobantes", "Comprobantes de pago y dispersión"],
  ["anexos", "Anexos y cartas"],
  ["otros", "Otros documentos"],
];
